import {
    HISTORY_REMINDER_FETCH,
    HISTORY_SYNTHESIS_LOADING,
    HISTORY_SYNTHESIS_LOADED,
    HISTORY_ALERT_DISPLAY,
    HISTORY_ALERT_HIDE,
} from '../actions/types'

interface HistoryStore {
    alertMessage: string
    isAlertOpened: boolean
    synthesisLoading: boolean
    isReminderEnabled: boolean
}

const INITIAL_STATE: HistoryStore = {
    isAlertOpened: false,
    alertMessage: '',
    synthesisLoading: false,
    isReminderEnabled: false,
}

export default (state = INITIAL_STATE, action: any): HistoryStore => {
    switch (action.type) {
        case HISTORY_REMINDER_FETCH:
            return {
                ...state,
                isReminderEnabled: action.payload,
            }
        case HISTORY_SYNTHESIS_LOADING:
            return {
                ...state,
                synthesisLoading: true,
            }
        case HISTORY_SYNTHESIS_LOADED:
            return {
                ...state,
                synthesisLoading: false,
            }
        case HISTORY_ALERT_DISPLAY:
            return {
                ...state,
                isAlertOpened: true,
                alertMessage: action.payload,
            }
        case HISTORY_ALERT_HIDE:
            return {
                ...state,
                isAlertOpened: false,
                alertMessage: '',
            }
        default:
            return state
    }
}
